const clearCountsState = (state) => {
  state.reward_counts = [];
  state.impression_counts = [];
  state.graph_counts = [];
}

const addRewardCount = (state, payload) => {
  var alreadyPresent = false;

  for (var j = 0; j < state.reward_counts.length; j++) {
    if (state.reward_counts[j].id === payload.advertiser_id) {
      state.reward_counts[j].counts.push(payload.counts);
      alreadyPresent = true;
    }
  }

  if (!alreadyPresent) {
    const newRewardCount = {
      id: payload.advertiser_id,
      counts: [payload.counts],
    }
    state.reward_counts.push(newRewardCount);
  }
}

const addImpressionCount = (state, payload) => {
  var alreadyPresent = false;
  for (var j = 0; j < state.impression_counts.length; j++) {
    if (state.impression_counts[j].id === payload.advertiser_id) {
      state.impression_counts[j].counts.push(payload.counts);
      alreadyPresent = true;
    }
  }

  if (!alreadyPresent) {
    const newImpressionCount = {
      id: payload.advertiser_id,
      counts: [payload.counts],
    }
    state.impression_counts.push(newImpressionCount);
  }
}

const addGraphCounts = (state, payload) => {
  var alreadyPresent = false;

  for (var i = 0; i < state.graph_counts.length; i++) { 
    if (state.graph_counts[i].id === payload.data.id) {
      state.graph_counts[i][payload.time_period][payload.count_type] = payload.data.counts;
      alreadyPresent = true;
    }
  }

  if (!alreadyPresent) {
    const newCount = {
      "id": payload.data.id,
      "This Week": {
        "Total Redemptions": {},
        "New Redemptions": {},
        "Returning Redemptions": {},
        "Profile Clicks": {},
        "Brand Impressions": {},
      },
      "Last Week": {
        "Total Redemptions": {},
        "New Redemptions": {},
        "Returning Redemptions": {},
        "Profile Clicks": {},
        "Brand Impressions": {},
      },
      "Last 7 Days": {
        "Total Redemptions": {},
        "New Redemptions": {},
        "Returning Redemptions": {},
        "Profile Clicks": {},
        "Brand Impressions": {},
      },
      "Last 30 Days": {
        "Total Redemptions": {},
        "New Redemptions": {},
        "Returning Redemptions": {},
        "Profile Clicks": {},
        "Brand Impressions": {},
      },
      "Year To Date": {
        "Total Redemptions": {},
        "New Redemptions": {},
        "Returning Redemptions": {},
        "Profile Clicks": {},
        "Brand Impressions": {},
      },
      "Last 12 Months": {
        "Total Redemptions": {},
        "New Redemptions": {},
        "Returning Redemptions": {},
        "Profile Clicks": {},
        "Brand Impressions": {},
      },
    }
    newCount[payload.time_period][payload.count_type] = payload.data.counts;
    state.graph_counts.push(newCount);
  }
}

export default {
  clearCountsState,
  addRewardCount,
  addImpressionCount,
  addGraphCounts,
}